import type {Company} from './CustomerPaymentCommon';
import { Header} from './CustomerPaymentCommon'
import css from './CustomerPaymentPage.less'
import React from 'react'

export function CompanyBlock(company: Company) {
    return (
        <div className={css.companyArea}>
            {company.logo ? <img alt={`${company.name} logo`} src={company.logo.url} style={{
                minHeight: '40px',
                width: company.logo.width,
                maxHeight: '80px',
                minWidth: '80px',
                height: company.logo.height,
                maxWidth: '240px',
            }}/> : null}
            <div>
                <Header>{company.name}</Header>
                <div className={css.companyAddress}>{company.address}</div>
            </div>
        </div>
    )
}
